import { APIFY, HTTP_CLIENT } from "./services/Api";

const loginwithuid = async (user, history) => {
  let params = { uid: user.uid };

  HTTP_CLIENT(APIFY("/users/loginwithUid"), "POST", params)
    .then((res) => {
      const user = res.data;

      if (res && user && user.email) {
        localStorage.setItem("IsLogged", true);
        localStorage.setItem("userEmail", user.email);
        localStorage.setItem("access_token", user.token);

        history.push("/home");
      } else {
        register(user);
      }
    })
    .catch((err) => {
      register(user);
    });
};

const register = async (user) => {
  let params = {
    uid: user.uid,
    name: user.displayName,
    authProvider: "google",
    email: user.email,
    password: "",
    phone: "",
    role: ["user"],
  };

  HTTP_CLIENT(APIFY("/users/register"), "POST", params)
    .then((data) => {
      const user = data.data;
      loginwithuid(user.uid);
    })
    .catch((err) => {});
};

export async function loginUser(email, password) {
  // Implement your own login logic here
  // This would typically call your backend API
  try {
    const response = await HTTP_CLIENT(APIFY("/users/login"), "POST", {
      email,
      password,
    });
    
    if (response.data && response.data.token) {
      localStorage.setItem("IsLogged", true);
      localStorage.setItem("userEmail", email);
      localStorage.setItem("access_token", response.data.token);
      return true;
    }
    return false;
  } catch (error) {
    alert(error.message);
    return false;
  }
}

export async function registerUser(email, password, name, phone) {
  try {
    const params = {
      name,
      email,
      password,
      phone,
      role: ["user"],
    };

    const response = await HTTP_CLIENT(APIFY("/users/register"), "POST", params);
    
    if (response.data) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
}

export async function getData(name) {
  // Implement your own data fetching logic
  try {
    const response = await HTTP_CLIENT(APIFY(`/cities/${name}`), "GET");
    return response.data || { error: "No such document!" };
  } catch (error) {
    return { error: "No such document!" };
  }
}

export async function getDataByCollection(name) {
  let data = [];

  try {
    data = await HTTP_CLIENT(APIFY(`/${name}`), "GET", {})
      .then((res) => {
        if (res.data) {
          data = res.data;
        }
        return data;
      })
      .catch((err) => {});

    return data;
  } catch {
    return data;
  }
}

export async function getDataById(id) {
  let data = [];

  try {
    data = await HTTP_CLIENT(APIFY(`/${id}`), "GET", {})
      .then((res) => {
        if (res.data) {
          data = res.data;
        }
        return data;
      })
      .catch((err) => {
        console.log("errorr", err);
      });

    return data;
  } catch {
    return data;
  }
}

export async function getFilteredData(colle, key, value, type = null, limit = 0) {
  let data = [];

  try {
    data = await HTTP_CLIENT(
      APIFY(`/${colle}`),
      "GET",
      {},
      {
        [`${key}`]: value,
        limit: limit,
      }
    )
      .then((res) => {
        if (type != null) {
          data = res;
        } else if (res.data) {
          data = res.data;
        }
        return data;
      })
      .catch((err) => {});

    return data;
  } catch {
    return data;
  }
}

export async function getMultiFilteredData(colle, filter) {
  let data = [];

  try {
    data = await HTTP_CLIENT(
      APIFY(`/${colle}`),
      "GET",
      {},
      {
        ...filter,
        limit: 0,
      }
    )
      .then((res) => {
        if (res.data) {
          data = res.data;
        }
        return data;
      })
      .catch((err) => {});

    return data;
  } catch {
    return data;
  }
}

export async function getStateList(payload) {
  let data = [];
  try {
    data = await HTTP_CLIENT(APIFY(`/country/state-city`), "GET", null, payload)
      .then((res) => {
        if (res.data) {
          data = res.data;
        }
        return data;
      })
      .catch((err) => {});

    return data;
  } catch {
    return data;
  }
}

export async function getLatestAppVersion() {
  let data = [];
  try {
    data = await HTTP_CLIENT(APIFY(`/app-version`), "GET", null, null)
      .then((res) => {
        data = res;
        return data;
      })
      .catch((err) => {});

    return data;
  } catch {
    return data;
  }
}

export async function getCityData(key, value) {
  let data = [];

  try {
    data = await HTTP_CLIENT(APIFY(`/district/search`), "POST", {
      state: key,
      city: value,
      limit: 0,
    })
      .then((res) => {
        if (res.data) {
          data = res.data;
        }
        return data;
      })
      .catch((err) => {});

    return data;
  } catch {
    return data;
  }
}

export async function QueryDistrictUpdate() {
  // This function appears to be for data migration
  // You can remove it or adapt it to your new backend
  console.log("QueryDistrictUpdate function removed - no Firebase dependency");
}

export function sendEmailVerification(email) {
  // Implement your own email verification logic
  console.log("Email verification would be sent to:", email);
}

// Remove all Firebase-specific exports and functions
export default {};